import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth.slice';
import companySettingsSlice from './slices/company-settings.slice';
import enumsSlice from './slices/enums.slice';
import moduleSlice from './slices/module.slice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    module: moduleSlice.reducer,
    companySettings: companySettingsSlice.reducer,
    enums: enumsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
